/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
// import PDFViewer from 'pdf-viewer-reactjs';
import React, { useState } from 'react';
import cookies from 'react-cookies';
import { Document, Page, pdfjs } from 'react-pdf';
import { useHistory } from 'react-router-dom';
import iconDownload from '../../../../assets/icons/download-docs.svg';
import { LoaderIcon, Loader } from '../../../Loader';
import { Content, LabelCheck, ButtonPdf } from './styles';
import api from '../../../../services/api';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.workee.js';

const DocPdf = ({ pdf }: any) => {
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();
  const [numPages, setNumPages] = useState(1);
  if (localStorage.getItem('pdfLink')) {
    return (
      <Document
        className="pdfMobile"
        loading={Loader}
        error="Verifique se você está logado e tente novamente!"
        onLoadError={async errorEvent => {
          localStorage.removeItem('pdfLink');
          history.push('/');
        }}
        file={localStorage.getItem('pdfLink')}
      >
        <Page pageNumber={currentPage} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ButtonPdf
            disabled={currentPage === 1}
            onClick={() => {
              if (currentPage > 1) {
                setCurrentPage(currentPage - 1);
              }
            }}
          >
            Anterior
          </ButtonPdf>
          <label style={{ margin: 20 }}>{`${currentPage} / ${numPages}`}</label>
          <ButtonPdf
            disabled={currentPage === numPages}
            onClick={() => {
              if (currentPage < numPages) {
                setCurrentPage(currentPage + 1);
              }
            }}
          >
            Próxima
          </ButtonPdf>
        </div>
      </Document>
    );
  }
  return (
    <Document
      loading={Loader}
      onLoadSuccess={async successEvent => {
        successEvent.getData().then(call => {
          const blob = new Blob([call], { type: 'application/pdf' });
          if (blob)
            localStorage.setItem('pdfLink', `${URL.createObjectURL(blob)}`);
        });
        setNumPages(successEvent.numPages);
      }}
      onLoadError={async errorEvent => {
        console.log(errorEvent.message);
        history.push('/notfound');
      }}
      file={{
        url: pdf,
        httpHeaders: {
          Authorization: `Bearer ${cookies.load('external_token')}`,
        },
      }}
    >
      <Page pageNumber={currentPage} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ButtonPdf
          disabled={currentPage === 1}
          onClick={() => {
            if (currentPage > 1) {
              setCurrentPage(currentPage - 1);
            }
          }}
        >
          Anterior
        </ButtonPdf>
        <label style={{ margin: 20 }}>{`${currentPage} / ${numPages}`}</label>
        <ButtonPdf
          disabled={currentPage === numPages}
          onClick={() => {
            if (currentPage < numPages) {
              setCurrentPage(currentPage + 1);
            }
          }}
        >
          Próxima
        </ButtonPdf>
      </div>
    </Document>
  );
};
const PDF = ({ pdf }: any) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [check, setCheck] = useState(false);
  const [idPdf] = useState(localStorage.getItem('idpdf'));
  const [showButton, setShowButton] = useState(0);
  const [showCheck, setShowCheck] = useState(1);
  const history = useHistory();
  const [btnLoad, setBtnLoad] = useState(false);

  function handleDownloadPdf() {
    const blob = localStorage.getItem('pdfLink');
    try {
      if (blob) window.open(blob);
    } catch (error) {
      console.log('PDF não disponível para download');
    }
  }

  async function handleClickAccepted(e: any) {
    e.preventDefault();
    if (check && idPdf) {
      setBtnLoad(!btnLoad);
      await api.post(
        `/v0/gps/merchants/${cookies.load(
          'external_stone_codes',
        )}/terms-of-service/${idPdf}/accept`,
        {},
        {
          headers: {
            Authorization: `Bearer ${cookies.load('external_token')}`,
          },
        },
      );
      setBtnLoad(!btnLoad);
      history.push('/');
    }
  }
  return (
    <Content>
      <h1>Termos e Condições</h1>
      {/* <DocPdf pdf={pdf} pageNumber={pageNumber} /> */}
      <section>
        <form
          onSubmit={e => {
            handleClickAccepted(e);
          }}
        >
          <LabelCheck
            htmlFor="r1"
            onClick={e => {
              e.preventDefault();
              setCheck(true);
              setShowButton(1);
              setShowCheck(0);
            }}
            style={{ opacity: showCheck, zIndex: showCheck }}
          >
            <span />
            <input
              type="checkbox"
              checked={check}
              id="r1"
              onChange={e => {
                e.preventDefault();
                setShowButton(1);
                setShowCheck(0);
              }}
            />
            <p>
              Eu aceito os Termos e Condições do produto Gestão de Pagamentos
              Stone.
            </p>
          </LabelCheck>
          {!btnLoad ? (
            <button
              type="submit"
              className="btnIn"
              onClick={e => handleClickAccepted(e)}
              style={{
                opacity: showButton,
                zIndex: showButton,
                transition: '1s',
              }}
            >
              Confirmar
            </button>
          ) : (
            <LoaderIcon />
          )}
          <div style={{ marginTop: 20 }}>
            <a href="#" onClick={handleDownloadPdf}>
              <img src={iconDownload} alt="Icone de Donwload" />
              Baixar arquivo
            </a>
            <a href={`${process.env.REACT_APP_GPS_ENDPOINT}`}>
              Recusar o contrato
            </a>
          </div>
        </form>
      </section>
    </Content>
  );
};

export default PDF;
